import { takeEvery, put } from 'redux-saga/effects';
import * as types from './constants';
import { Layout } from '@components/layout'
import {TOASTER_DISPATCH} from './constants';
// import {generatePath, matchPath} from 'react-router';
// import {CATALOG_ITEM, CATALOG_LIST} from '~/router/routes';
// import {history} from '~/router/history';

// function* redirectToCatalog() {
//     let { params } = matchPath(window.location.pathname, {
//         path: CATALOG_ITEM
//     });
//     yield history.push(generatePath(CATALOG_LIST, params));
// }

function* rootSagas() {
    yield takeEvery([
        types.TOASTER_DISPATCH
    ], Layout.actions.showMessageSaga);
    yield takeEvery([
        'ws:UI/ToasterNotification'
    ], function* ({data: {message, messageType}}) {
        yield put({
            type: TOASTER_DISPATCH,
            toast: {
                type: messageType,
                message: message,
            }
        })
    });

    yield takeEvery([
        types.LAYOUT_SIDEBAR_OPEN,
    ], function* (payload) {
        localStorage.setItem('sidebarState', 'true');
    });

    yield takeEvery([
        types.LAYOUT_SIDEBAR_CLOSE,
    ], function* (payload) {
        localStorage.setItem('sidebarState', 'false');
    });

    yield takeEvery([
        types.TOGGLE_SUB_MENU,
    ], function* (payload) {
        localStorage.setItem(`${payload.name}MenuState`, `${!(localStorage.getItem(`${payload.name}MenuState`) === 'true')}`);
    });

    yield takeEvery([
        'ws:Company/CompanyCountersNotification',
    ], function* (payload) {
        yield put({
            type: types.UPDATE_COUNTERS,
            data: payload.data,
        })
    });

    yield takeEvery([
        'ws:Company/CompanyChatCountersNotification',
    ], function* (payload) {
        yield put({
            type: types.UPDATE_CHAT_COUNTERS,
            data: payload.data,
        })
    });

    yield takeEvery([
        'ws:User/NotificationsListNotification',
    ], function* (payload) {
        yield put({
            type: types.UPDATE_NOTIFICATIONS_LIST,
            notifications: payload.data.notifications,
        })
    });
}

export default rootSagas;
